/**
 * ATIN custom product page script.
 * Handles variant selection, refill bundle upsell, and add-to-cart.
 *
 * Loaded by sections/main-product-atin.liquid.
 */
(function () {
  "use strict";

  var section = document.querySelector("[data-atin-product-section]");
  if (!section) return;

  var dataEl = section.querySelector("[data-atin-product-json]");
  if (!dataEl) return;

  var productData;
  try {
    productData = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // ---------------- state ----------------
  var selectedOptions = [];
  var mainVariant = productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
  if (mainVariant) {
    selectedOptions = mainVariant.options.slice();
  }

  var quantity = 1;
  // refillState: Record<handle, { variantId: number, qty: number, priceCents: number }>
  var refillState = {};

  // ---------------- elements ----------------
  var qtyInput = section.querySelector("[data-atin-qty-input]");
  var qtyInc = section.querySelector("[data-atin-qty-increase]");
  var qtyDec = section.querySelector("[data-atin-qty-decrease]");
  var priceEl = section.querySelector("[data-atin-price]");
  var mainVariantInput = section.querySelector("[data-atin-main-variant]");
  var totalWrap = section.querySelector("[data-atin-total]");
  var totalValue = section.querySelector("[data-atin-total-value]");
  var ctaBtn = section.querySelector("[data-atin-submit]");
  var ctaLabel = section.querySelector("[data-atin-cta-label]");
  var ctaStatus = section.querySelector("[data-atin-cta-status]");
  var refillCount = section.querySelector("[data-atin-refill-count]");
  var form = section.querySelector("[data-atin-form]");

  // ---------------- helpers ----------------
  function formatMoney(cents) {
    // Shopify's money_format is embedded but parsing it reliably is messy.
    // Simple version: use Intl.NumberFormat with PHP (Philippine Peso).
    var pesos = cents / 100;
    try {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits: 2,
      }).format(pesos);
    } catch (e) {
      return "\u20B1" + pesos.toFixed(2);
    }
  }

  function findVariantForOptions(opts) {
    return productData.variants.find(function (v) {
      if (v.options.length !== opts.length) return false;
      for (var i = 0; i < opts.length; i++) {
        if (v.options[i] !== opts[i]) return false;
      }
      return true;
    });
  }

  // ---------------- variant selection ----------------
  var variantPills = section.querySelectorAll("[data-atin-option-value]");
  variantPills.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var value = btn.getAttribute("data-atin-option-value");
      var pos = parseInt(btn.getAttribute("data-atin-option-position"), 10) - 1;

      selectedOptions[pos] = value;

      // Update pill UI — deselect ALL pills in group (including bundle)
      var group = btn.parentElement;
      group.querySelectorAll(".atin-pdp__pill").forEach(function (b) {
        b.classList.remove("atin-pdp__pill--active");
      });
      btn.classList.add("atin-pdp__pill--active");

      // Update label value
      var header = group.previousElementSibling;
      if (header) {
        var labelValue = header.querySelector(".atin-pdp__label-value");
        if (labelValue) labelValue.textContent = value;
      }

      // Find matching variant
      var newVariant = findVariantForOptions(selectedOptions);
      if (newVariant) {
        mainVariant = newVariant;
        if (mainVariantInput) mainVariantInput.value = newVariant.id;
        if (priceEl) priceEl.textContent = formatMoney(newVariant.price);
        ctaBtn.disabled = !newVariant.available;
        if (ctaLabel) ctaLabel.textContent = newVariant.available ? "Add to Cart" : "Sold Out";

        // Swap product image if variant has its own image
        if (newVariant.featured_image) {
          var mainImg = section.querySelector('.atin-pdp__image');
          if (mainImg) {
            mainImg.src = newVariant.featured_image;
            mainImg.srcset = '';
          }
        }

        // If the selected scent has a matching refill, highlight it as recommended
        highlightRecommendedRefill(value);

        // Update per-scent fragrance notes
        updateScentNotes(value);
      }

      // Exit bundle mode when selecting a single variant
      bundleMode = false;

      updateTotal();
    });
  });

  // ---------------- per-scent fragrance notes ----------------
  var scentNotesEl = section.querySelector("[data-atin-scent-notes-content]");
  var fullDescTemplate = section.querySelector("[data-atin-full-description]");
  var scentNotesMap = {};

  if (fullDescTemplate && scentNotesEl) {
    // Parse the full description into per-scent sections
    var rawText = fullDescTemplate.textContent
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&#39;/g, "'").replace(/&quot;/g, '"')
      .replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '');

    // Split by scent name headers (e.g. "BORACAY -", "DALANDAN -", etc.)
    var scentPattern = /\b([A-Z][A-Z\s]{2,})\s*[\-–—]\s*/g;
    var matches = [];
    var match;
    while ((match = scentPattern.exec(rawText)) !== null) {
      matches.push({ name: match[1].trim(), index: match.index, end: match.index + match[0].length });
    }

    for (var i = 0; i < matches.length; i++) {
      var scentName = matches[i].name;
      var startIdx = matches[i].end;
      var endIdx = (i + 1 < matches.length) ? matches[i + 1].index : rawText.length;
      var content = rawText.substring(startIdx, endIdx).trim();

      // Clean up and format
      var lines = content.split('\n').filter(function(l) { return l.trim() !== ''; });
      var formatted = lines.map(function(line) {
        line = line.trim();
        if (line.match(/^(Category|Top Notes|Middle Notes|Dry Down Notes|Base Notes):/i)) {
          return '<strong>' + line + '</strong>';
        }
        return '<p style="margin:0 0 8px;">' + line + '</p>';
      }).join('');

      // Map by lowercase first word for matching against variant names
      var key = scentName.charAt(0) + scentName.slice(1).toLowerCase();
      scentNotesMap[key] = formatted;
      scentNotesMap[scentName] = formatted;
      scentNotesMap[scentName.toLowerCase()] = formatted;
    }

    // Show notes for the initially selected scent
    if (mainVariant && mainVariant.options && mainVariant.options[0]) {
      updateScentNotes(mainVariant.options[0]);
    }
  }

  function updateScentNotes(scentValue) {
    if (!scentNotesEl) return;
    // Try to find matching notes
    var notes = scentNotesMap[scentValue] ||
                scentNotesMap[scentValue.toUpperCase()] ||
                scentNotesMap[scentValue.toLowerCase()];
    if (notes) {
      scentNotesEl.innerHTML = notes;
    } else {
      scentNotesEl.innerHTML = '<p style="opacity:0.5;font-size:14px;">No fragrance notes available for ' + scentValue + '.</p>';
    }
  }

  // ---------------- Complete Collection (bundle all variants) ----------------
  var bundleMode = false;
  var bundleBtn = section.querySelector("[data-atin-bundle-all]");
  if (bundleBtn) {
    bundleBtn.addEventListener("click", function () {
      bundleMode = true;

      // Update pill UI — deselect all individual pills, select bundle pill
      var group = bundleBtn.parentElement;
      group.querySelectorAll("[data-atin-option-value]").forEach(function (b) {
        b.classList.remove("atin-pdp__pill--active");
      });
      bundleBtn.classList.add("atin-pdp__pill--active");

      // Update label
      var header = group.previousElementSibling;
      if (header) {
        var labelValue = header.querySelector(".atin-pdp__label-value");
        if (labelValue) labelValue.textContent = "All Variants";
      }

      // Calculate total price for all available variants with 10% off
      var allVariants = productData.variants.filter(function (v) { return v.available; });
      var fullPrice = allVariants.reduce(function (sum, v) { return sum + v.price; }, 0);
      var bundlePrice = Math.round(fullPrice * 0.9);
      if (priceEl) priceEl.innerHTML = '<span style="text-decoration:line-through;opacity:0.5;">' + formatMoney(fullPrice) + '</span> ' + formatMoney(bundlePrice) + ' <span style="font-size:0.7em;color:#c4d4a0;">(10% off)</span>';

      // Show the group photo (product featured image with all variants)
      var mainImg = section.querySelector('.atin-pdp__image');
      var groupSrc = mainImg ? mainImg.getAttribute('data-group-src') : null;
      if (mainImg && groupSrc) {
        mainImg.src = groupSrc;
        mainImg.srcset = '';
      }

      // Update CTA
      ctaBtn.disabled = false;
      if (ctaLabel) ctaLabel.textContent = "Add Complete Collection";

      updateTotal();
    });
  }

  // Save original image src for bundle mode
  var mainImgEl = section.querySelector('.atin-pdp__image');
  if (mainImgEl) {
    mainImgEl.setAttribute('data-original-src', mainImgEl.src);
  }

  function highlightRecommendedRefill(scent) {
    var refillHandle = productData.scentToRefill && productData.scentToRefill[scent];
    // Clear all "recommended" flags
    section.querySelectorAll("[data-atin-refill-row]").forEach(function (row) {
      row.removeAttribute("data-recommended");
    });
    if (!refillHandle) return;
    var match = section.querySelector('[data-atin-refill-row][data-refill-handle="' + refillHandle + '"]');
    if (match) {
      match.setAttribute("data-recommended", "true");
      // Move it to the top of the refill list
      var parent = match.parentElement;
      if (parent && parent.firstChild !== match) {
        parent.insertBefore(match, parent.firstChild);
      }
    }
  }

  // ---------------- quantity ----------------
  function setQty(n) {
    quantity = Math.max(1, n);
    if (qtyInput) qtyInput.value = quantity;
    updateTotal();
    // Reset button from "Added ✓" back to "Add to Cart" when quantity changes
    if (ctaLabel && ctaLabel.textContent !== "Add to Cart" && ctaLabel.textContent !== "Sold Out") {
      ctaLabel.textContent = "Add to Cart";
      ctaBtn.disabled = false;
    }
  }
  if (qtyInc) qtyInc.addEventListener("click", function () { setQty(Math.min(99, quantity + 1)); });
  if (qtyDec) qtyDec.addEventListener("click", function () { setQty(Math.max(1, quantity - 1)); });
  if (qtyInput) {
    qtyInput.addEventListener("change", function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      setQty(v);
    });
    qtyInput.addEventListener("input", function () {
      qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
    });
  }

  // ---------------- refill rows ----------------
  section.querySelectorAll("[data-atin-refill-row]").forEach(function (row) {
    var handle = row.getAttribute("data-refill-handle");
    var addBtn = row.querySelector("[data-atin-refill-add]");
    var stepper = row.querySelector(".atin-pdp__refill-stepper");
    var qtyLabel = row.querySelector("[data-atin-refill-qty]");
    var incBtn = row.querySelector("[data-atin-refill-increase]");
    var decBtn = row.querySelector("[data-atin-refill-decrease]");
    var variantId = addBtn ? addBtn.getAttribute("data-variant-id") : null;
    var priceCents = addBtn ? parseInt(addBtn.getAttribute("data-price-cents"), 10) : 0;

    function render() {
      var entry = refillState[handle];
      var qty = entry ? entry.qty : 0;
      if (qty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (qtyLabel) qtyLabel.textContent = qty;
        row.setAttribute("data-selected", "true");
      } else {
        if (addBtn) addBtn.hidden = false;
        if (stepper) stepper.hidden = true;
        row.removeAttribute("data-selected");
      }
      updateRefillCount();
      updateTotal();
    }

    function setQty(n) {
      if (n <= 0) {
        delete refillState[handle];
      } else {
        refillState[handle] = { variantId: parseInt(variantId, 10), qty: n, priceCents: priceCents };
      }
      render();
    }

    if (addBtn) addBtn.addEventListener("click", function () { setQty(1); });
    if (incBtn) incBtn.addEventListener("click", function () {
      var current = refillState[handle] ? refillState[handle].qty : 0;
      setQty(current + 1);
    });
    if (decBtn) decBtn.addEventListener("click", function () {
      var current = refillState[handle] ? refillState[handle].qty : 0;
      setQty(current - 1);
    });
  });

  function updateRefillCount() {
    var total = Object.keys(refillState).reduce(function (sum, handle) {
      return sum + refillState[handle].qty;
    }, 0);
    if (refillCount) {
      if (total > 0) {
        refillCount.textContent = total + " selected";
        refillCount.hidden = false;
      } else {
        refillCount.hidden = true;
      }
    }
  }

  // ---------------- total ----------------
  function updateTotal() {
    var base;
    if (bundleMode) {
      var fullBase = productData.variants.filter(function (v) { return v.available; })
        .reduce(function (sum, v) { return sum + v.price; }, 0);
      base = Math.round(fullBase * 0.9);
    } else {
      base = (mainVariant ? mainVariant.price : 0) * quantity;
    }
    var refillsTotal = 0;
    Object.keys(refillState).forEach(function (h) {
      var e = refillState[h];
      refillsTotal += e.priceCents * e.qty;
    });
    var hasRefills = Object.keys(refillState).length > 0;
    var grand = base + refillsTotal;

    if (totalWrap && totalValue) {
      if (hasRefills) {
        totalWrap.hidden = false;
        totalValue.textContent = formatMoney(grand);
      } else {
        totalWrap.hidden = true;
      }
    }

    if (ctaLabel && ((mainVariant && mainVariant.available) || bundleMode)) {
      if (bundleMode) {
        ctaLabel.textContent = "Add Complete Collection \u2014 " + formatMoney(base);
      } else if (hasRefills) {
        ctaLabel.textContent = "Add Bundle to Cart \u2014 " + formatMoney(grand);
      } else {
        ctaLabel.textContent = "Add to Cart";
      }
    }
  }

  // ---------------- submit ----------------
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!bundleMode && (!mainVariant || !mainVariant.available)) return;

      ctaBtn.disabled = true;
      if (ctaLabel) ctaLabel.textContent = "Adding...";
      if (ctaStatus) {
        ctaStatus.textContent = "";
        ctaStatus.removeAttribute("data-state");
      }

      var items = [];
      if (bundleMode) {
        // Add 1 of each available variant
        productData.variants.forEach(function (v) {
          if (v.available) {
            items.push({ id: v.id, quantity: 1 });
          }
        });
      } else {
        items.push({ id: mainVariant.id, quantity: quantity });
      }
      Object.keys(refillState).forEach(function (h) {
        var e = refillState[h];
        items.push({ id: e.variantId, quantity: e.qty });
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) { throw err; });
          }
          return res.json();
        })
        .then(function () {
          if (ctaLabel) ctaLabel.textContent = "Added \u2713";
          if (ctaStatus) ctaStatus.textContent = "";

          // Show "View Cart" button alongside the Add to Cart button
          var viewCartBtn = document.querySelector('[data-atin-view-cart]');
          if (viewCartBtn) {
            viewCartBtn.removeAttribute('hidden');
          }

          // Update cart count in header
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var badges = document.querySelectorAll('.atin-nav__cart-count');
              badges.forEach(function(b) {
                if (cart.item_count > 0) {
                  b.textContent = cart.item_count;
                  b.removeAttribute('data-empty');
                } else {
                  b.textContent = '';
                  b.setAttribute('data-empty', 'true');
                }
                b.style.display = cart.item_count > 0 ? 'flex' : 'none';
              });
            });

          // Keep "Added ✓" state — button stays disabled until quantity changes
          ctaBtn.disabled = true;
        })
        .catch(function (err) {
          ctaBtn.disabled = false;
          if (ctaLabel) ctaLabel.textContent = "Add to Cart";
          if (ctaStatus) {
            ctaStatus.setAttribute("data-state", "error");
            ctaStatus.textContent = (err && err.description) || "Could not add to cart. Please try again.";
          }
        });
    });
  }

  // ---------------- init ----------------
  if (mainVariant) {
    // Pre-highlight the refill matching the current scent
    var scentOption = null;
    var optionNames = productData.variants[0] ? Object.keys(productData.variants[0]) : [];
    // Find which option index is the "Scent"
    for (var i = 0; i < mainVariant.options.length; i++) {
      var val = mainVariant.options[i];
      if (productData.scentToRefill && productData.scentToRefill[val]) {
        scentOption = val;
        break;
      }
    }
    if (scentOption) highlightRecommendedRefill(scentOption);
  }
  updateTotal();
})();
